import { useMemo } from "react";
import { useGetThreeSixtyAmendmentList } from "../../api/ThreeSixtyAPI";
import { useMyAssignedCheckTypes } from "../../api/ActorAPI";
import { usePermissionValidator } from "../../api/UserPermissionValidators";

import {
  HeaderField,
  WithFilterSortHeader,
  WithFilterSortHeaderBaseProps,
  WithFilterSortHeaderInjectedProps,
} from "../FilterSortHeader";
import { ThreeSixtyListBase } from "../ThreeSixtyListBase";
import { ThreeSixtyAmendmentRowRenderer } from "../ThreeSixtyAmendmentRowRenderer";
import { ThreeSixtyAmendmentRow } from "../../api/ThreeSixty";

type ThreeSixtyAmendmentBaseProps = {};
const ThreeSixtyAmendmentBase = (
  props: ThreeSixtyAmendmentBaseProps &
    WithFilterSortHeaderBaseProps &
    WithFilterSortHeaderInjectedProps
) => {
  const perms = usePermissionValidator();

  return (
    <ThreeSixtyListBase
      {...props}
      hasPermission={perms.canEditAmendment360}
      renderRow={(row, cancel, toggleCancel, forceReload) => (
        <ThreeSixtyAmendmentRowRenderer
          key={row.request_uuid}
          row={row as ThreeSixtyAmendmentRow}
          cancel={cancel}
          toggleCancel={toggleCancel}
          forceReload={forceReload}
        />
      )}
    />
  );
};

const ThreeSixtyAmendmentWithFilterSortHeader = WithFilterSortHeader(
  ThreeSixtyAmendmentBase
);

type ThreeSixtyAmendmentProps = {};
const ThreeSixtyAmendment = (props: ThreeSixtyAmendmentProps) => {
  const { data: assignedCheckTypes } = useMyAssignedCheckTypes();
  const headerDefs = useMemo<HeaderField[][]>(
    () => [
    [
      {
        display: "Name",
        value_field: "name",
        filterable: true,
        sortable: true,
      },
      {
        display: "Report ID",
        value_field: "request_uuid",
        filterable: false,
        sortable: true,
      },
    ],
    [
      {
        display: "Company",
        value_field: "company_name",
        filterable: true,
        sortable: true,
      },
    ],
    [
      {
        display: "Check Type",
        key_field: "check_type_uuid",
        value_field: "check_type_name",
        filterable: true,
        sortable: true,
        preFilter: assignedCheckTypes?.has_task
          ? assignedCheckTypes.check_type_uuids
          : undefined,
      },
      {
        display: "Behavior Kit",
        value_field: "behavior_kit_name",
        filterable: false,
        sortable: true,
      },
    ],
    [
      {
        display: "Originally Completed",
        value_field: "finished_at",
        filterable: true,
        sortable: true,
      },
    ],
    [
      {
        display: "Amendment Opened",
        value_field: "amendment_opened_at",
        filterable: true,
        sortable: true,
      },
    ],
    [
      {
        display: "Assigned To",
        value_field: "locked_by",
        filterable: true,
        sortable: true,
      },
    ],
    [
      {
        display: "Client Ref #",
        value_field: "custom_id",
        filterable: true,
        sortable: true,
      },
    ],
  ],
  [assignedCheckTypes]
  );
  return (
    <ThreeSixtyAmendmentWithFilterSortHeader
      page_size={20}
      date_fields={["amendment_opened_at", "finished_at", "due_date"]}
      default_sort_field="due_date"
      default_sort_reverse
      loader={useGetThreeSixtyAmendmentList()}
      header_definitions={headerDefs}
    />
  );
};

export default ThreeSixtyAmendment;
